import { GridPaginationModel } from "@mui/x-data-grid-premium";

class HastaRaporListesiRequests {
    baslangicTarih?: string = null;
    bitisTarih?: string = null;
    alinmaSekliId?: number = null;
    dokuTemelOzellikId?: number = null;
    raporTipId?: number = null;
    raporYetkiId?: number = null;
    nlpAranacakDeger?: string = "";
    morfolojiKoduIds?: string = null;
    paginationModel?: GridPaginationModel = { page: 0, pageSize: 100 };
};
export default HastaRaporListesiRequests;